import LogoGrid from "components/organisms/LogoGrid"

const Customers = ({ pageContext: { currentPage } }) => {
  return (
    <div className="my-10 lg:my-20">
      <LogoGrid center currentPage={currentPage} />
    </div>
  )
}

export default Customers
